<template>
  <CHeader fixed :with-subheader="showSubheader" :class="{'impersonating': isImpersonating}">
    <CToggler
        in-header
        class="ml-3 d-lg-none"
        @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
        in-header
        class="ml-3 d-md-down-none"
        @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <CIcon name="logoMinimized" height="30" alt="Logo" viewBox="0 0 69 68"/>
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">

    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <!-- TODO: temporaneamente nascosto
      <PendingInvitationsBadge/>
      -->
      <ImpersonateBadge/>
      <TheHeaderDropdownAccount @open-company-management="openCompanyManagement"/>
      <CompanyManagementModal ref="companyManagementModal"/>
    </CHeaderNav>

    <CSubheader class="px-3" v-if="showSubheader">
      <SimpleBreadcrumbRouter class="border-0 mb-0"/>
    </CSubheader>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccount from './TheHeaderDropdownAccount.vue'
import CompanyManagementModal from '@/domain/payout/components/CompanyManagementModal.vue'
import SimpleBreadcrumbRouter from "../components/SimpleBreadcrumbRouter"
import ImpersonateBadge from "@/domain/impersonate/ImpersonateBadge.vue"
// TODO: temporaneamente disabilitato
// import PendingInvitationsBadge from "@/domain/invitations/components/PendingInvitationsBadge.vue"
import {mapActions, mapGetters} from "vuex"
import eventBus from "@/domain/core/constant/eventBus"

export default {
  name: 'TheHeader',
  components: {
    ImpersonateBadge,
    CompanyManagementModal,
    // PendingInvitationsBadge,
    TheHeaderDropdownAccount,
    SimpleBreadcrumbRouter,
  },
  props: {
    showSubheader: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('impersonate', [
      'isImpersonating',
    ])
  },
  mounted() {
    this.registerEvent(eventBus.events.created, this.onStatusChanged)
    this.registerEvent(eventBus.certification.submitted, this.onStatusChanged)
    this.registerEvent(eventBus.certification.open, this.openCompanyManagement)
    this.registerEvent(eventBus.event.published, this.onStatusChanged)
    this.registerEvent(eventBus.event.pay_as_you_go, this.onStatusChanged)
  },
  beforeDestroy() {
    this.unregisterEvent(eventBus.events.created, this.onStatusChanged)
    this.unregisterEvent(eventBus.certification.submitted, this.onStatusChanged)
    this.unregisterEvent(eventBus.certification.open, this.openCompanyManagement)
    this.unregisterEvent(eventBus.event.published, this.onStatusChanged)
    this.unregisterEvent(eventBus.event.pay_as_you_go, this.onStatusChanged)
  },
  methods: {
    ...mapActions('userStatus', {refreshUserStatus: 'fetchStatus'}),
    ...mapActions('login', ['refreshPermissions']),
    async onStatusChanged() {
      await Promise.all([
        this.refreshUserStatus(),
        this.refreshPermissions()
      ])
    },
    openCompanyManagement(cmId = null) {
      this.$refs.companyManagementModal.open(cmId)
    }
  }
}
</script>
